export type TodoTag = 'lead' | 'form' | 'website' | 'general';

export type TodoSourceType = 'lead' | 'form' | 'website' | 'product' | 'media';

export interface Todo {
  id: string;
  user_id: string;
  title: string;
  description: string | null;
  due_date: string;
  completed: boolean;
  tag: TodoTag | null;
  source_type: TodoSourceType | null;
  source_id: string | null;
  created_at: string;
  updated_at: string;
}

export interface TodoSource {
  type: TodoSourceType;
  id: string;
  name: string;
  subtitle?: string;
  slug?: string;
}

export interface TodoWithSource extends Todo {
  source?: TodoSource;
}

export interface CreateTodoInput {
  title: string;
  description?: string;
  due_date: string;
  tag?: TodoTag;
  source_type?: TodoSourceType;
  source_id?: string;
}

export interface UpdateTodoInput {
  title?: string;
  description?: string | null;
  due_date?: string;
  completed?: boolean;
  tag?: TodoTag | null;
}

export type TodoGroup = 'OVERDUE' | 'TODAY' | 'TOMORROW' | 'THIS_WEEK' | 'LATER' | 'COMPLETED';

export const TODO_TAG_LABELS: Record<TodoTag, string> = {
  lead: 'Lead',
  form: 'Formular',
  website: 'Website',
  general: 'Allgemein',
};

export const TODO_TAG_COLORS: Record<TodoTag, { bg: string; text: string }> = {
  lead: { bg: 'bg-blue-100', text: 'text-blue-700' },
  form: { bg: 'bg-rose-100', text: 'text-rose-700' },
  website: { bg: 'bg-emerald-100', text: 'text-emerald-700' },
  general: { bg: 'bg-violet-100', text: 'text-violet-700' },
};

export const TODO_SOURCE_TYPE_LABELS: Record<TodoSourceType, string> = {
  lead: 'Lead',
  form: 'Formular',
  website: 'Website',
  product: 'Produkt',
  media: 'Medien',
};

export const TODO_GROUP_LABELS: Record<TodoGroup, string> = {
  OVERDUE: 'Überfällig',
  TODAY: 'Heute',
  TOMORROW: 'Morgen',
  THIS_WEEK: 'Diese Woche',
  LATER: 'Später',
  COMPLETED: 'Erledigt',
};

export const TODO_GROUP_ORDER: TodoGroup[] = ['OVERDUE', 'TODAY', 'TOMORROW', 'THIS_WEEK', 'LATER', 'COMPLETED'];
